import { useEffect, useState } from "react";
import "./SiteBanner.scss";
import { CloseOutlined } from "@ant-design/icons";
import { getCookie, isLandingPath, isPrintPath, setSiteBannerCookie } from "../util/utils";
import { Popover } from "antd";
import { useLocation } from "react-router-dom";

// Set to true to show banner
const bannerOn = false;

// Mode can be "top", "bottom", or "banner"
const bannerMode = "bottom";

enum VisibleMode {
    Visible,
    Hidden,
}

export function SiteBanner() {
    const loc = useLocation();
    const [showBanner, setShowBanner] = useState(getCookie("showSiteBanner") === "false" ? false : bannerOn);
    const [mode, setMode] = useState(VisibleMode.Visible);

    useEffect(() => {
        const { pathname } = loc;
        if (isLandingPath(pathname) || isPrintPath(pathname)) {
            setMode(VisibleMode.Hidden);
        } else {
            setMode(VisibleMode.Visible);
        }
    }, [loc]);

    function onClose(ev: any) {
        ev.stopPropagation();
        setShowBanner(false);
        setSiteBannerCookie(false);
    }

    return (
        mode === VisibleMode.Hidden ? null : <>
        {showBanner && <div className={`header-promo-banner ${bannerMode}`}>
            <div className="banner-content">
                <div className="banner-text">
                    <b>
                        Downloading Issue Found - click&nbsp;
                        <Popover trigger="click" overlayStyle={{maxWidth: "400px"}} content={
                            <div>
                                Dear Customer,<br/><br/>
                                Some customers are having troubles downloading menus due to a conflict with certain security software. Menu downloads and Display menu board downloads are affected. We have identified the problem and are working on a solution. This issue requires us to resolve conflicts with 3rd party ISPs. We greatly appreciate your patience and we apologize for the inconvenience!<br/><br/>
                                Possible Workaround: A workaround is to download via your phone. Or, chat with customer service to have your menus emailed to you.<br/><br/>
                                We will stick with this issue until it's resolved. Please don't hesitate to contact us. Thank you!<br/><br/>
                                Your MustHaveMenus Team
                            </div>}>
                            <span style={{cursor: "pointer"}}><u>here</u></span>
                        </Popover> for info
                    </b>
                </div>
                <div className="close-btn" onClick={(ev) => onClose(ev)}><CloseOutlined/></div>
            </div>
        </div>}
    </>);
}
